import { createContext } from 'react';

interface RequestedPriceContextInfo {
  requestedPrice: number | undefined;
  setRequestedPrice: (price: number) => void;
}

export default createContext<RequestedPriceContextInfo>({
  requestedPrice: undefined,
  setRequestedPrice: () => {},
});
